import dropdown from 'scoreboard/components/dropdown'
import getRollupIsAnyFilters from 'scoreboard/datasets/filters/get-rollup-is-any-filters'
import _ from 'lodash'

/**
 * Given a select element, add the rollup permission options
 * and select the default value.
 *
 * This also calls selects() on the select element.
 *
 * @param {jQuery} select
 *
 * @param {String} selectedValue
 *
 * @param {boolean} [options.isPermissionFilter=false]
 * if this dropdown is for a permissions filter or not
 *
 * @param {boolean} [options.labelFn=({id, key}) => key] Allows a customized label
 */
function rollupFilterDropdown(select, selectedValue,  options = {}) {

	const {isPermissionFilter, labelFn} = _.extend({
		isPermissionFilter: false,
		labelFn: option => option.key
	}, options)

	const selectOptions =_.map(getRollupIsAnyFilters(isPermissionFilter), opt => ({
		id: opt.id,
		label: labelFn(opt)
	}))
	dropdown.idLabels(select, selectOptions, selectedValue)
}

export default rollupFilterDropdown
rollupFilterDropdown.__filename__ = 'datasets/filters/rollup-filter-dropdown.js'
